<div class="kng-charts" *ngIf="state.chart">
  <p *ngIf="state?.loading" class="loader">
    <img  src="{{loaderState.imagePath }}" alt="loader" />
  </p>
 
  <div *ngIf="!state?.loading">
    <div class="kng-charts__header">
    <div class="kng-charts__title" [ngClass]="{'gray-scale':state.comingSoon}">
      <span tabindex="0">{{ state.chart.title }}</span>
      <span *ngIf="state.chart.infoPresent && !state.comingSoon">
        <img matTooltipPosition="right" matTooltip={{state.chart.tooltip?.content}} tabindex="0"
          class="info-image--desktop-view " #tooltipdesktop="matTooltip" (window:scroll)="tooltipdesktop.hide()"
          attr.aria-label="{{ state.chart.tooltip?.content }}" alt="info icon" src="assets/info_desktop.svg"
          matTooltipClass="{{state.chart.tooltipClass? state.chart.tooltipClass : 'chartTooltip'}}"
          matTooltipPositionAtOrigin="true">
        <img id="tooltip-{{state.chart.id}}" matTooltipPosition="below" tabindex="0" (click)="showTooltip()"
          attr.aria-label="{{ state.chart.tooltip?.content }}" class="info-image--mobile-view " alt="info icon"
          src="assets/info_mobile.svg">
      </span>
     </div>
    <button tabindex="0" *ngIf="!state.comingSoon" class="kng-charts__cta-link" (click)="ctaLinkClick($event)">
      {{ state.chart.cta.label }}
    </button>
    
  </div>
  <ng-container *ngIf="state?.comingSoon">
        
    <p class="coming-soon"  tabindex="0">
     <img  src="{{comingSoon.imagePath }}" tabindex="0" alt="Coming Soon" />
    </p>
    <p class="coming-soon-text"  tabindex="0">
     {{comingSoon.imageText}}
    </p>
   </ng-container>
</div>

<div class="error" *ngIf="state?.error && !state?.loading">
  <img src="{{state?.errorState?.imagePath}}" alt="error-forklift">
  <span class="title">{{state?.errorState?.titleText}}</span>
  <span class="sub-title">{{state?.errorState?.subTitleText}}</span>
</div>

<div class="kng-charts__summary-units" *ngIf="!state?.loading && !state?.error && !state.comingSoon">
  <div *ngFor="let unit of state.chart.summaryUnits" class="kng-charts__sumary-container d-flex align-items-end">
    <div class="kng-charts__summary-unit-label" tabindex="0">{{ unit.label ? unit.label: '-'}}</div>
    <div class="kng-charts__summary-unit-description" tabindex="0">
      {{ unit.description }}
    </div>
  </div>
  <div class="kng-charts__changeSummary" *ngIf="state.chart.changeSummary && !state.chart.changeSummary.noChange">
    <div class="change-icon d-flex justify-content-center" role="button" tabindex="0" [ngClass]="{'fontGreen upArrow': state.chart.changeSummary.isPositive, 'downArrow': !state.chart.changeSummary.isPositive }"></div>
    <p class="kng-charts__changeSummary--value" [ngClass]="{'fontGreen': state.chart.changeSummary.isPositive }">{{state.chart.changeSummary.changeSummaryValue}}</p>
  </div>
</div>

<div class="kng-charts__container" *ngIf="!state?.loading && !state?.error && !state.comingSoon" >
  <canvas *ngIf="!state.chart.showNoDataText" tabindex="0" #chart baseChart role="img"
    [attr.aria-label]="state.chart.ariaLabel ? state.chart.ariaLabel : state.chart.chart.type"
    [data]="state.chart.chart.data" [plugins]="state.chart.chart.plugins" [options]="state.chart.chart.options" [type]="state.chart.chart.type">
  </canvas>
  <div *ngIf="state.chart.showNoDataText" class="kng-charts__no-data-found">
    <span>{{ state.chart.noDataText}}</span>
  </div>
  <ng-content [select]="lockedContent"></ng-content>
</div>

<div class="kng-charts__custom-legends" *ngIf="!state?.loading && !state?.error && state.chart.customLegend && !state.comingSoon" aria-label="chart-legends">
  <div class="kng-charts__custom-legends--y-axis" tabindex="0">{{state.chart.customLegend.yAxis.label}}
    {{state.chart.customLegend.yAxis.value}}</div>
  <div class="kng-charts__custom-legends--x-axis" tabindex="0">{{state.chart.customLegend.xAxis.label}}
    {{state.chart.customLegend.xAxis.value}}</div>
</div>
</div>